import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();
export default async function saveAgreementData(leadId, section, data) {
	console.log('This is the saveAgreementData data', data);
	if (section === 'individual') {
		let keys = Object.keys(data);
		keys.map(async (key) => {
			await firebaseRef
				.ref(
					'/kavtek_agreements/' +
						PROJECT_CODE.projectCode +
						'/' +
						leadId +
						'/clientInfo/' +
						section +
						'/' +
						key
				)
				.once('value', async (snapshot) => {
					var agreementData = snapshot.val();
					await firebaseRef
						.ref(
							'/kavtek_agreements/' +
								PROJECT_CODE.projectCode +
								'/' +
								leadId +
								'/clientInfo/' +
								section
						)
						.update({
							[key]: {
								...agreementData, // to keep identification info
								address1: data[key]?.address1 || '',
								address2: data[key]?.address2 || '',
								city: data[key]?.city || '',
								email: data[key]?.email || '',
								firstName: data[key]?.firstName || '',
								lastName: data[key]?.lastName || '',
								occupation: data[key]?.occupation || '',
								phoneNumber: data[key]?.phoneNumber || '',
								postalCode: data[key]?.postalCode || '',
								province: data[key]?.province || '',
							},
						});
					if (data[key]?.dateOfBirth) {
						// To update date of birth for deal review purchaser information
						await firebaseRef
							.ref(
								'/kavtek_agreements/' +
									PROJECT_CODE.projectCode +
									'/' +
									leadId +
									'/clientInfo/' +
									section +
									'/' +
									key +
									'/identification/report/document'
							)
							.update({ dateOfBirth: data[key]?.dateOfBirth });
					}
				});
		});
	} else if (section === 'corporation') {
		await firebaseRef
			.ref(
				'/kavtek_agreements/' +
					PROJECT_CODE.projectCode +
					'/' +
					leadId +
					'/clientInfo/' +
					section
			)
			.update({
				address1: data?.address1 || '',
				address2: data?.address2 || '',
				city: data?.address1 || '',
				corporationName: data?.corporationName || '',
				directorFirstName: data?.directorFirstName || '',
				directorLastName: data?.directorLastName || '',
				registrationNumber: data?.registrationNumber || '',
				typeOfBusiness: data?.typeOfBusiness || '',
				postalCode: data?.postalCode || '',
				province: data?.province || '',
			});
	} else {
		await firebaseRef
			.ref(
				'/kavtek_agreements/' + PROJECT_CODE.projectCode + '/' + leadId
			)
			.once('value', async (snapshot) => {
				var agreementData = snapshot.val();
				console.log(
					'saveAgreementData agreementData',
					leadId,
					section,
					data
				);
				data &&
					(await firebaseRef
						.ref('/kavtek_agreements/' + PROJECT_CODE.projectCode)
						.update({
							[leadId]: {
								...agreementData,
								[section]: data || null,
							},
						}));
			});
	}
}
